import React, { createContext, useState, useEffect, ReactNode } from 'react';

type CurrencyType = 'USD' | 'EUR' | 'GBP' | 'JPY' | 'CAD' | 'AUD' | 'INR';

interface CurrencyContextType {
  currency: CurrencyType;
  setCurrency: (currency: CurrencyType) => void;
  currencySymbol: string;
}

export const CurrencyContext = createContext<CurrencyContextType>({
  currency: 'USD',
  setCurrency: () => {},
  currencySymbol: '$'
});

interface CurrencyProviderProps {
  children: ReactNode;
}

const currencySymbols: Record<CurrencyType, string> = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  CAD: 'CA$',
  AUD: 'A$',
  INR: '₹'
};

export const CurrencyProvider: React.FC<CurrencyProviderProps> = ({ children }) => {
  const [currency, setCurrency] = useState<CurrencyType>(() => {
    // Check if currency preference is stored in localStorage
    const savedCurrency = localStorage.getItem('currency') as CurrencyType;
    return savedCurrency || 'USD';
  });

  const [currencySymbol, setCurrencySymbol] = useState<string>(currencySymbols[currency]);

  useEffect(() => {
    // Update localStorage when currency changes
    localStorage.setItem('currency', currency);
    setCurrencySymbol(currencySymbols[currency]);
  }, [currency]);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, currencySymbol }}>
      {children}
    </CurrencyContext.Provider>
  );
};
